import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { Feature } from '../../core';
import { FeatureService } from '../../services';

@Directive({
  selector: '[scipRequiresFeature]'
})
export class RequiresFeatureDirective {
  constructor(private viewContainer: ViewContainerRef, private templateRef: TemplateRef<any>, private featureService: FeatureService) {}

  @Input()
  set scipRequiresFeature(features: Feature | Feature[]) {
    if (this.featureService.isActive(features)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
